<script>
import store from '@state/store'
import Layout from '@layouts/guest.vue'
import { authMethods } from '@state/helpers'
import VerifyPhone from '@guest/components/verify-phone.vue'

export default {
  page: {
    meta: [{ name: 'description', content: `Log in to KyndHub` }],
  },
  components: { Layout, VerifyPhone },
  data() {
    return {
      username: '',
      password: '',
      authError: '',
      tryingToVerifyPhone: false,
      success: false,
    }
  },
  computed: {},
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    postPhone(params) {
      this.tryingToVerifyPhone = true
      return this.verifyPhone({
        phonePrefix: params.prefix,
        phoneNumber: params.phone,
      })
        .then((response) => {
          this.tryingToVerifyPhone = false
          // Redirect to the originally requested page, or to the home page
          // this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
        })
        .catch((error) => {
          this.tryingToVerifyPhone = false
          this.authError = error
        })
    },
    skip(params) {
      this.tryingToVerifyPhone = true
      return this.skipPhone()
        .then((response) => {
          this.tryingToVerifyPhone = false
          // Redirect to the originally requested page, or to the home page
          this.redirectFunc()
        })
        .catch((error) => {
          this.tryingToVerifyPhone = false
          this.authError = error
        })
    },
    postResend(params) {
      this.tryingToVerifyPhone = true
      return this.resendCode()
        .then((response) => {
          this.tryingToVerifyPhone = false
          // Redirect to the originally requested page, or to the home page
          // this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
        })
        .catch((error) => {
          this.tryingToVerifyPhone = false
          this.authError = error
        })
    },
    redirectFunc() {
      store.dispatch('auth/validate', true).then((user) => {
        const companyId =
          user.default_company_id && user.default_company_id !== 0
            ? user.default_company_id
            : 2944
        var goToRoute = {
          name: 'company',
          params: { companyId },
        }
        if (user.phone === '' && user.skip_verify_phone !== 1) {
          goToRoute = { name: 'verify-phone' }
        }
        // Redirect to the originally requested page, or to the default company or to phone verification
        this.$router.push(this.$route.query.redirectFrom || goToRoute)
      })
    },
    postCode(params) {
      this.tryingToVerifyPhone = true
      return this.verifyCode({
        smsCode: params.code,
      })
        .then((response) => {
          this.tryingToVerifyPhone = false
          if (response.success === true) {
            this.redirectFunc()
            // this.$router.push(
            //   this.$route.query.redirectFrom || { name: 'home' }
            // )
          }
          // Redirect to the originally requested page, or to the home page
        })
        .catch((error) => {
          this.tryingToVerifyPhone = false
          this.authError = error
        })
    },
    clearAuthErrors() {
      this.authError = ''
    },
  },
}
</script>

<template>
  <Layout>
    <VerifyPhone
      :auth-error="authError"
      @skip="skip"
      @post-phone="postPhone"
      @resend-code="postResend"
      @verify-code="postCode"
      @clear-auth-errors="clearAuthErrors"
    ></VerifyPhone>
  </Layout>
</template>
